/* unplugin-vue-components disabled */import { render } from "./HRhome.vue?vue&type=template&id=0f82907a&scoped=true"
import script from "./HRhome.vue?vue&type=script&lang=js"
export * from "./HRhome.vue?vue&type=script&lang=js"

import "@/assets/css/init/column.less?vue&type=style&index=0&id=0f82907a&lang=less&scoped=true"
import "@/assets/css/home/home.less?vue&type=style&index=1&id=0f82907a&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f82907a"]])

export default __exports__